import type { ValidPropertyValidationResult } from './types';

export const VALID_RESULT: ValidPropertyValidationResult = {
	isValid: true,
};
